import { observable } from "mobx";
import React from "react";
import moment from "moment";
import SailingBreakdownService from "../../../../services/SailingBreakdownService";
import {formatarDataCustomHTML} from "../../../../utils/formatar";
import { buscaFiltrarVazio, buscaSemResultado } from '../../../../utils/mensagens';
import { sortCaret } from '../../../comum/components/Icones';


export default class SailingBreakdownStore {

    @observable seletorPeriodo;
    @observable dataInicial;
    @observable dataFinal;
    @observable loading;
    @observable operacoes;
    @observable allowDownloadPdf;
    @observable tableMessage;
    @observable total
    @observable itens;
    @observable hasMore;

    constructor() {
        this.seletorPeriodo = false;
        this.dataInicial = moment().subtract(7, 'day').format("YYYY-MM-DD");
        this.dataFinal = moment().add(0, 'day').format("YYYY-MM-DD");
        this.loading = false;
        this.operacoes = [];
        this.itens = [];
        this.toShow = 20;
        this.turn = 0;
        this.allowDownloadPdf = false;
        this.filtrado = false;
        this.total = null

        this.colunas = [{
            dataField: 'Operacao',
            text: 'Operação',
            sort: true,
            sortCaret: sortCaret,
        }, {
            dataField: 'NavioNome',
            text: 'Navio',
            sort: true,
            sortCaret: sortCaret,
        }, {
            text: 'Fim Operação',
            dataField: 'DtFimReal',
            formatter: formatarDataCustomHTML,
            sort: true,
            sortCaret: sortCaret,
        }, 
        {
            text: '',
            dataField: 'link',
            isDummyField: true,
            formatter : (cell, row) => <a target="_blank" href={this.linkPDF(row.Operacao)} >Detalhes</a>,
        }];

        this.sailingBreakdownService = new SailingBreakdownService();

        this.tableMessage = buscaFiltrarVazio
    }

    setDataInicioTemp = (value) => {
        this.dataInicialTemp = value;
    };

    setDataFimTemp = (value) => {
        this.dataFinalTemp = value;
    };

    alterarPeriodo(){
        if(this.dataInicialTemp && this.dataFinalTemp){
            this.dataInicial = this.dataInicialTemp;
            this.dataFinal = this.dataFinalTemp;
        }
        //this.carregarLista();
    }

    alternarDataSeletor = () => {
        this.seletorPeriodo = !this.seletorPeriodo;
    };

    loadFirstTurn = () => {
        this.itens = this.operacoes.slice(0, this.toShow);
        this.turn = 1;
        this.hasMore = this.itens.length < this.operacoes.length;
    };

    loadNextTurn = () => {
        this.itens = [];
        this.itens = this.operacoes.slice(0, (this.turn+1)*this.toShow);
        this.turn = this.turn+1;

        this.hasMore = this.itens.length < this.operacoes.length;
    };

    pesquisar = () => {
        this.filtrado = true;
        this.loading = true;
        this.operacoes = []

        this.tableMessage = buscaSemResultado

        this.sailingBreakdownService.listarOperacoes(this.dataInicial, this.dataFinal).then(response => {
            this.operacoes = response.data.Data
            this.loadFirstTurn()
            this.total = response.data.Total
            this.loading = false;
            if(response.data.Data.length > 0){
                this.allowDownloadPdf = true;
            }else{
                this.allowDownloadPdf = false;
            }
        }).catch( erro => {
            console.log(erro)
            this.loading = false;
        });
    };

    linkPDF (operacao){
        return this.sailingBreakdownService.relatorio(operacao.split(' - ')[1]);
    }

}


// WEBPACK FOOTER //
// ./src/modules/consultas/sailing-breakdown/stores/SailingBreakdownStore.js